import "./TestPanelResultTeamplateDownloadComponent.scss";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../shared/services";
import {ITableColumn} from "../../../shared/models/table.model";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SearchComponent from "../../../shared/components/search/SearchComponent";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../constants";
import commonService from "../../../shared/services/common.service";
import HeadingComponent from "../../../shared/components/heading/headingComponent";

interface TestPanelResultTeamplateDownloadComponentProps {
    onTemplateDrawerClose: Function;
}

const TestPanelResultTeamplateDownloadComponent = (props: TestPanelResultTeamplateDownloadComponentProps) => {

    const {onTemplateDrawerClose} = props;
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const [currentLoadingItem, setCurrentLoadingItem] = useState<any>(null);
    const [filterData, setFilterData] = useState<any>({
        search: '',
        isResultTemplateAvailable: true
    });

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
        CommonService.setQueryParam('search', value);
    }, []);

    useEffect(() => {
        if (queryParamData) {
            setFilterData((prevState: any) => ({
                ...prevState,
                search: queryParamData.search || '',
            }));
        }
    }, [queryParamData]);

    const columns: ITableColumn[] = [
        {id: 'name', label: 'Test Panel', isDefaultColumn: true},

        {
            id: 'actions', label: 'Action', sortable: false, isDefaultColumn: true,
            content: (item: any) => (
                <ButtonComponent
                    color={'secondary'}
                    variant={'outlined'}
                    startIcon={<ArrowDownwardIcon/>}
                    isLoading={currentLoadingItem === item?.id}
                    handleClick={() => {
                        downloadResultExcel(item)
                    }}
                >Download XLS</ButtonComponent>
            )
        },
    ];

    const downloadResultExcel = useCallback((item: any) => {
        const payload = {
            testId: item.id,
        }
        setCurrentLoadingItem(item?.id);
        commonService._result.getResultTestTemplate( payload)
            .then((res: any) => {
                setCurrentLoadingItem(null);
                CommonService.downloadFile(res?.data?.attachmentUrl, res?.data?.title || 'result.csv', res?.data?.type || 'csv')
            })
            .catch((err: any) => {
                setCurrentLoadingItem(null);
                commonService._alert.showToast("Something went wrong", 'error');
            });
    }, []);

    return (
        <div className={'test-result-template-download-component screen t-form-screen'}>
            <div className="drawer-sub-header horizontal-vertical-center-align">
                <HeadingComponent title={"Download Templates"}/>
            </div>
            <div className={'t-form'}>
                <div className={'no-form t-form-drawer'}>
                    <div className={'t-form-controls-wrapper pdd-top-20'}>
                        <SearchComponent
                            label={"Search Test Panel"}
                            id="search_input"
                            placeholder={""}
                            value={filterData.search}
                            onChange={handleSearch}
                        />

                        <TableWrapperV2Component
                            url={APIConfig.TEST_LIST.URL}
                            method={APIConfig.TEST_LIST.METHOD}
                            isPaginated={true}
                            columns={columns}
                            extraPayload={filterData}
                            isHoverable={true}
                            isStickyHeader={true}
                            isColumnFilterVisible={false}
                        />

                    </div>
                    <div className="drawer-actions form-action-section">
                        <ButtonComponent fullWidth={true}
                                         color={'primary'}
                                         handleClick={onTemplateDrawerClose}
                        >
                            Close
                        </ButtonComponent>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default TestPanelResultTeamplateDownloadComponent;